import BaseModule from './BaseModule.js';

class BankWebhook extends BaseModule {
  async paginate({ page, per_page, term }) {
    return await this.get(`back-office/bank-webhooks`, { params: { page, per_page, term } });
  }

  async fetch(id) {
    return await this.get(`/back-office/bank-webhooks/${id}`);
  }

  async fetchWithProvider(id, provider) {
    return await this.post(`/back-office/bank-webhooks/fetch-by-provider`, {
      id: id,
      provider: provider,
    });
  }

  async create(data) {
    return await this.post(`/back-office/bank-webhooks`, data);
  }

  async update(data) {
    return await this.patch(`/back-office/bank-webhooks/${data.id}`, data);
  }

  async remove(id) {
    return await this.delete(`/back-office/bank-webhooks/${id}`);
  }

  async fetchLimit(id) {
    return await this.get(`/back-office/bank-webhooks/limit/${id}`);
  }
}

export default BankWebhook;
